import { render, staticRenderFns } from "./RentalVenueSpaceBody.vue?vue&type=template&id=7704fd28&scoped=true&"
import script from "./RentalVenueSpaceBody.vue?vue&type=script&lang=js&"
export * from "./RentalVenueSpaceBody.vue?vue&type=script&lang=js&"
import style0 from "./RentalVenueSpaceBody.vue?vue&type=style&index=0&id=7704fd28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7704fd28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7704fd28')) {
      api.createRecord('7704fd28', component.options)
    } else {
      api.reload('7704fd28', component.options)
    }
    module.hot.accept("./RentalVenueSpaceBody.vue?vue&type=template&id=7704fd28&scoped=true&", function () {
      api.rerender('7704fd28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Organizers/RentalVenueSpace/RentalVenueSpaceBody.vue"
export default component.exports